import { FC } from "react"

import { ThemeEnum, TThemeStyles } from "domain/customization/types"

import * as S from "./styled"
import VisaIcon from "./icons/VISA.svg"
import { getPaletteByColor } from "./utils"

type TCardFormWidgetPageProps = {
  config: TThemeStyles
  theme: ThemeEnum
}

export const CardFormWidgetPage: FC<TCardFormWidgetPageProps> = ({
  config,
  theme,
}) => {
  const firstTextColor = theme === ThemeEnum.Light ? "#000000" : "#E5E5E5"
  const inputBorder = theme === ThemeEnum.Light ? "#e5e5e5 " : "#404040"
  const backBtnBg = theme === ThemeEnum.Light ? "#F2F2F2 " : "#262626"
  const topIconPalette = getPaletteByColor(config.secondaryColor)
  const topIconColor =
    theme === ThemeEnum.Light ? topIconPalette?.color400 : "#1A1A1A"

  return (
    <S.Wrapp $color={config.secondaryBackground}>
      <S.MenuIcon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M5 7.00049H19M5 12.0005H19M5 17.0005H19" stroke="#808080" />
        </svg>
      </S.MenuIcon>
      <S.Top
        $primaryBg={config.primaryBackground}
        $bg={config.secondaryBackground}
      >
        <S.TopIcon $bg={config.secondaryBackground}>
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <path
              d="M48 41V23C48 21.8954 47.1046 21 46 21H18C16.8954 21 16 21.8954 16 23V41C16 42.1046 16.8954 43 18 43H46C47.1046 43 48 42.1046 48 41Z"
              fill="#FFFFFF"
            />
            <path
              opacity="0.75"
              d="M48 41V23C48 21.8954 47.1046 21 46 21H18C16.8954 21 16 21.8954 16 23V41C16 42.1046 16.8954 43 18 43H46C47.1046 43 48 42.1046 48 41Z"
              fill={topIconColor}
            />
            <path
              d="M19.5 29H44.5C45.3284 29 46 28.3284 46 27.5C46 26.6716 45.3284 26 44.5 26H19.5C18.6716 26 18 26.6716 18 27.5C18 28.3284 18.6716 29 19.5 29Z"
              fill="#FFFFFF"
            />
            <path
              opacity="0.5"
              d="M19.5 29H44.5C45.3284 29 46 28.3284 46 27.5C46 26.6716 45.3284 26 44.5 26H19.5C18.6716 26 18 26.6716 18 27.5C18 28.3284 18.6716 29 19.5 29Z"
              fill={topIconColor}
            />
            <path
              d="M19.5 39H23.5C24.3284 39 25 38.3284 25 37.5C25 36.6716 24.3284 36 23.5 36H19.5C18.6716 36 18 36.6716 18 37.5C18 38.3284 18.6716 39 19.5 39Z"
              fill={config.secondaryBackground}
            />
          </svg>
        </S.TopIcon>

        <S.Title $color={firstTextColor}>Payment by card</S.Title>
        <S.Subtitle>Total amount: 100.00 EUR</S.Subtitle>
      </S.Top>

      <S.Content>
        <S.Input $color={firstTextColor} $border={inputBorder}>
          <S.InputLabel $bg={config.secondaryBackground}>
            Card number
          </S.InputLabel>
          4000 0000 0000 0077
          <img src={VisaIcon} alt="Visa" />
        </S.Input>
        <S.Input $color={firstTextColor} $border={inputBorder}>
          <S.InputLabel $bg={config.secondaryBackground}>
            Cardholder name
          </S.InputLabel>
          JOHN DOE
        </S.Input>
        <S.CardSecret>
          <S.Input $color={firstTextColor} $border={inputBorder}>
            <S.InputLabel $bg={config.secondaryBackground}>
              Expiry date
            </S.InputLabel>
            01/30
          </S.Input>
          <S.Input $color={firstTextColor} $border={inputBorder}>
            <S.InputLabel $bg={config.secondaryBackground}>
              CVV2/CVC2
            </S.InputLabel>
            &#x2022;&#x2022;&#x2022;
          </S.Input>
        </S.CardSecret>

        <S.Checkbox>
          <S.CheckboxIcon $bg={config.primaryColor}>
            <svg
              width="18"
              height="13"
              viewBox="0 0 18 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 1L6 12L1 7"
                stroke="#5B5E61"
                strokeWidth="2"
                strokeLinejoin="round"
              />
            </svg>
          </S.CheckboxIcon>
          <S.ChecboxLabel>Save card</S.ChecboxLabel>
        </S.Checkbox>

        <S.Address $linkColor={config.secondaryColor}>
          Hardenbergstrasse 62, 55606 Kirn, Birmingham.{" "}
          <span>Edit address</span>
        </S.Address>

        <S.Btns>
          <S.BackBtn $bg={backBtnBg} $color={firstTextColor}>
            Back
          </S.BackBtn>
          <S.SubmitBtn
            $bg={config.primaryColor}
            $color={config.primaryTextColor}
          >
            Pay now
          </S.SubmitBtn>
        </S.Btns>
      </S.Content>
    </S.Wrapp>
  )
}
